import React from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { PhoneInput } from 'components/BaseInputs/PhoneInput';

const PHONE_REGEX = /^\d{3}-\d{3}-\d{4}(\s\d{1,4}|\s?)?$/;

export const ConnectedPhoneNumberInput = React.forwardRef(
  ({ name, rules, required, id, ...props }, ref) => {
    return (
      <Controller
        name={name}
        rules={{
          required,
          pattern: {
            value: PHONE_REGEX,
            message: 'Please enter a valid phone number',
          },
          ...rules,
        }}
        render={({
          field: { value, onChange, onBlur },
          fieldState: { invalid, error },
        }) => (
          <PhoneInput
            id={id ?? name}
            variant='outlined'
            size='small'
            fullWidth
            {...props}
            name={name}
            value={value || ''}
            onChange={(e) => {
              const value = e.target.value;
              onChange(value);
            }}
            onBlur={onBlur}
            inputProps={props.inputProps}
            ref={ref}
            error={invalid}
            helperText={error?.message}
            required={Boolean(required || rules?.required)}
          />
        )}
      />
    );
  },
);

ConnectedPhoneNumberInput.displayName = 'ConnectedPhoneNumberInput';

ConnectedPhoneNumberInput.propTypes = {
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
  capitalize: PropTypes.bool,
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
};
